import { PX_PER_MM, SVG_OFFSET } from "../constants/annotator"

// Match the SVG grid's physical spacing and fixed one-pixel strokes at every zoom.
export const createEcgPaperBackground = (scale) => {
	const smallBox = PX_PER_MM * scale
	const largeBox = smallBox * 5
	const size = largeBox * 5
	const lines = []
	for (let index = 0; index < 25; index++) {
		const x = index * smallBox + SVG_OFFSET
		lines.push(`<path d="M${x} 0V${size}" stroke-opacity=".2" stroke-dasharray="1 ${smallBox - 1}"/>`)
	}
	for (let index = 0; index < 5; index++) {
		const position = index * largeBox + SVG_OFFSET
		lines.push(`<path d="M${position} ${SVG_OFFSET}V${size}" stroke-opacity=".2"/>`)
		lines.push(`<path d="M0 ${position}H${size}" stroke-opacity="${index === 0 ? ".4" : ".2"}"/>`)
	}
	lines.push(`<path d="M${SVG_OFFSET} 0V${size}" stroke-opacity=".2"/>`)
	const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}"><g fill="none" stroke="#696969" stroke-width="1" shape-rendering="crispEdges">${lines.join("")}</g></svg>`
	return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`
}
